import { render } from "./SquareItemFullImage.vue?vue&type=template&id=ce4f68be&scoped=true&ts=true"
import script from "./SquareItemFullImage.vue?vue&type=script&lang=ts"
export * from "./SquareItemFullImage.vue?vue&type=script&lang=ts"

import "./SquareItemFullImage.vue?vue&type=style&index=0&id=ce4f68be&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce4f68be"]])

export default __exports__